import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { ArrowBackOutlined, DeleteOutlineOutlined } from '@mui/icons-material';
import i18next from 'i18next';

import { history } from 'helpers/history';
import { requiredValidation } from 'helpers/validations';
import { getAll } from 'services/persons.services';

import Input from 'components/inputs/Input';
import SelectInput from 'components/inputs/SelectInput';
import AutoComplete from 'components/inputs/AutoComplete';

import { ViewContainer, ViewContent, TitleContainer, Title, CustomIconButton } from 'styles/view';
import { FormContent, FormButtonContainer, FormSubmitButton } from 'styles/form';

import { IPerson } from 'types/persons.types';
import { IGravesFormProps } from './types';
import './i18n';

const GravesForm: FunctionComponent<IGravesFormProps> = (props: IGravesFormProps) => {
  const { initialValues, isEditing, onDelete, onSubmit, states } = props;

  return (
    <ViewContainer auth data-testid="graves-form">
      <ViewContent auth>
        <TitleContainer>
          <CustomIconButton onClick={history.goBack}>
            <ArrowBackOutlined />
          </CustomIconButton>
          <Title>{i18next.t<string>('GRAVES_FORM:TITLE')}</Title>
          {isEditing ? (
            <CustomIconButton danger onClick={onDelete}>
              <DeleteOutlineOutlined />
            </CustomIconButton>
          ) : (
            <div />
          )}
        </TitleContainer>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <FormContent onSubmit={handleSubmit}>
              <Field
                label={i18next.t<string>('GRAVES_FORM:STATE')}
                name="state"
                options={states}
                render={SelectInput}
                validate={requiredValidation}
              />
              <Field
                label={i18next.t<string>('GRAVES_FORM:ROW')}
                name="row"
                render={Input}
                type="number"
                validate={requiredValidation}
              />
              <Field
                label={i18next.t<string>('GRAVES_FORM:COLUMN')}
                name="column"
                render={Input}
                type="number"
                validate={requiredValidation}
              />
              <Field
                label={i18next.t<string>('GRAVES_FORM:PRICE')}
                name="price"
                render={Input}
                type="number"
                validate={requiredValidation}
              />
              <Field
                label={i18next.t<string>('GRAVES_FORM:COLOR')}
                name="color"
                parse={(value) => value}
                render={Input}
                type="color"
              />
              <Field
                label={i18next.t<string>('GRAVES_FORM:PERSON')}
                name="person"
                parse={(value) => value}
                render={(customProps) => (
                  <AutoComplete
                    {...customProps}
                    apiCall={(search) =>
                      getAll(10, 1, search, 'firstName', 'asc', Number(initialValues.personId))
                    }
                    apiCallKey="items"
                    itemLabel={(item: IPerson) =>
                      `${item.firstName} ${item.lastName} (${item.idCardTypeName}: ${item.idCard})`
                    }
                    itemValue="id"
                  />
                )}
              />
              <FormButtonContainer>
                <FormSubmitButton disabled={pristine || submitting} type="submit">
                  {i18next.t<string>('GRAVES_FORM:SUBMIT_BUTTON')}
                </FormSubmitButton>
              </FormButtonContainer>
            </FormContent>
          )}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default GravesForm;
